import script from "./ASFAdminDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ASFAdminDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ASFAdminDashboard.vue?vue&type=style&index=0&id=bafca550&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bafca550"]])

export default __exports__